import { useState } from "react";
import Swal from "sweetalert2";
import { bookInsideCover, bookOuterCover, bookPassword } from "../utils/constants";

export default function SecretMessage() {
  const [password, setPassword] = useState("");
  const [showEnterPass, setEnterPass] = useState(true);
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [error, setError] = useState("");

  const handleUnlock = () => {
    console.log(password, " andd ", bookPassword);
    if (password === bookPassword) {
      setIsUnlocked(true);
      setEnterPass(false);
      setError("");
    } else {
      setIsUnlocked(false);
      setError("Oops! Wrong password. Try again.");
    }
  };

  return (
    <div className="secretCode-root">
      <div className="secret-area">
        {showEnterPass && (
          <div className="password-root">
            <div className="password-div">
              <h2>Enter the Secret Code 💌</h2>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-4 px-4 py-2 border rounded-lg w-full text-center"
                placeholder="Enter secret password"
              />
              <button onClick={handleUnlock} className="mt-4 bg-pink-500 text-white px-6 py-2 rounded-lg shadow hover:bg-pink-600 transition">
                Unlock
              </button>
              <p>
                If you remember the year our hearts met, <br /> you know the key to this message
              </p>
              {error &&
                Swal.fire({
                  title: "Try again : )",
                  text: "Oops!! the password is wrong!!",
                  icon: "question",
                }).then(() => {
                  setError("");
                })}
            </div>
          </div>
        )}
        {isUnlocked && (
          <div>
            <h2>Click the image</h2>
            <div className="card-root">
              <div className="card">
                <div className="cover">
                  <img src={bookOuterCover} alt="" />
                  <img src={bookInsideCover} alt="" />
                </div>
                <div className="content">
                  <h2> A Special Note for You 💌</h2>
                  <p>
                    "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nam iure deserunt eligendi laudantium illum. Nam perferendis esse at consectetur,
                    laboriosam enim! Tenetur vero molestias perferendis neque, nobis aut impedit laudantium!. 💖 Yours, unknown"
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
